import FoldedHands from '@/shared/components/icons/FoldedHands.vue';
import PhoneScreen from '@/shared/components/icons/PhoneScreen.vue';
import AudioSquare from '@/shared/components/icons/AudioSquare.vue';
import VideoCameraRound from '@/shared/components/icons/VideoCameraRound.vue';
import type { NavItem } from '@/modules/admin/stores/admin-nav';

export const navItems: NavItem[] = [
  {
    title: 'Prayer Talks',
    icon: FoldedHands,
    routeName: 'prayerTalks',
  },
  {
    title: 'Unattached Slides',
    icon: PhoneScreen,
    routeName: 'prayerTalkSlides',
  },
  {
    title: 'Video backgrounds',
    icon: VideoCameraRound,
    routeName: 'prayerTalkVideos',
  },
  {
    title: 'Audio backgrounds',
    icon: AudioSquare,
    routeName: 'prayerTalkAudio',
  },
];
